import { MockServiceStore } from "./MockServiceStore";

export interface StructureCastRawMaterial {
  id: string;
  materialCode: string;
  name: string;
  category: "concrete" | "steel" | "hardware" | "chemical" | "formwork";
  unit: string;
  inStock: number;
  reserved: number;
  parLevel: number;
  reorderPoint: number;
  reorderQty: number;
  usagePerPiece: number;
  unitCost: number;
  vendor: string;
  leadTimeDays: number;
  lastOrderDate: string;
  notes?: string;
}

export const mockStructureCastRawMaterials: StructureCastRawMaterial[] = [
  {
    id: "rm-1",
    materialCode: "CONC-5000",
    name: "5,000 PSI Concrete Mix",
    category: "concrete",
    unit: "CY",
    inStock: 38.0,
    reserved: 10.0,
    parLevel: 55.0,
    reorderPoint: 18.0,
    reorderQty: 35.0,
    usagePerPiece: 0.9,
    unitCost: 215.0,
    vendor: "CalPortland — Santa Maria",
    leadTimeDays: 1,
    lastOrderDate: "2026-01-25",
  },
  {
    id: "rm-2",
    materialCode: "RBR-4-A615",
    name: "#4 Rebar ASTM A-706/A-615 Gr 60 (1/2\")",
    category: "steel",
    unit: "lf",
    inStock: 1500,
    reserved: 350,
    parLevel: 2200,
    reorderPoint: 600,
    reorderQty: 1100,
    usagePerPiece: 36,
    unitCost: 0.90,
    vendor: "Coast Steel & Rebar",
    leadTimeDays: 5,
    lastOrderDate: "2026-01-20",
  },
  {
    id: "rm-3",
    materialCode: "RBR-6-A615",
    name: "#6 Rebar ASTM A-706/A-615 Gr 60 (3/4\")",
    category: "steel",
    unit: "lf",
    inStock: 800,
    reserved: 220,
    parLevel: 1100,
    reorderPoint: 350,
    reorderQty: 600,
    usagePerPiece: 18,
    unitCost: 1.55,
    vendor: "Coast Steel & Rebar",
    leadTimeDays: 5,
    lastOrderDate: "2026-01-20",
  },
  {
    id: "rm-4",
    materialCode: "BOOT-HWB08",
    name: "Press-Seal HWB 8\" Cast-In Pipe Boot (S406)",
    category: "hardware",
    unit: "ea",
    inStock: 18,
    reserved: 8,
    parLevel: 26,
    reorderPoint: 10,
    reorderQty: 14,
    usagePerPiece: 1,
    unitCost: 72.0,
    vendor: "Press-Seal Corporation",
    leadTimeDays: 10,
    lastOrderDate: "2026-01-10",
  },
  {
    id: "rm-5",
    materialCode: "BOOT-HWB10",
    name: "Press-Seal HWB 10\" Cast-In Pipe Boot (S106)",
    category: "hardware",
    unit: "ea",
    inStock: 5,
    reserved: 6,
    parLevel: 14,
    reorderPoint: 7,
    reorderQty: 10,
    usagePerPiece: 1,
    unitCost: 88.0,
    vendor: "Press-Seal Corporation",
    leadTimeDays: 10,
    lastOrderDate: "2026-01-10",
    notes: "CRITICAL — reserved exceeds stock, 5 on back-order for Group 2 bases",
  },
  {
    id: "rm-6",
    materialCode: "BOOT-HWB12",
    name: "Press-Seal HWB 12\" Cast-In Pipe Boot",
    category: "hardware",
    unit: "ea",
    inStock: 8,
    reserved: 3,
    parLevel: 12,
    reorderPoint: 5,
    reorderQty: 8,
    usagePerPiece: 1,
    unitCost: 105.0,
    vendor: "Press-Seal Corporation",
    leadTimeDays: 10,
    lastOrderDate: "2026-01-10",
  },
  {
    id: "rm-7",
    materialCode: "SEAL-CS102",
    name: "CS-102 Butyl Sealant 1-1/8\"x14.5' (roll)",
    category: "chemical",
    unit: "rolls",
    inStock: 22,
    reserved: 18,
    parLevel: 36,
    reorderPoint: 12,
    reorderQty: 24,
    usagePerPiece: 0.5,
    unitCost: 18.0,
    vendor: "Concrete Sealants Inc (ConSeal)",
    leadTimeDays: 7,
    lastOrderDate: "2026-01-12",
    notes: "Low — running tight against Group 2/3 reservation; reorder pending",
  },
  {
    id: "rm-8",
    materialCode: "FRAME-1900",
    name: "1900 Sanitary Sewer CPH Frame",
    category: "hardware",
    unit: "ea",
    inStock: 9,
    reserved: 5,
    parLevel: 14,
    reorderPoint: 6,
    reorderQty: 10,
    usagePerPiece: 0,
    unitCost: 210.0,
    vendor: "Alhambra Foundry Co.",
    leadTimeDays: 14,
    lastOrderDate: "2025-12-15",
  },
  {
    id: "rm-9",
    materialCode: "COVER-1900",
    name: "1900 Sanitary Sewer CPH Cover",
    category: "hardware",
    unit: "ea",
    inStock: 10,
    reserved: 5,
    parLevel: 14,
    reorderPoint: 6,
    reorderQty: 10,
    usagePerPiece: 0,
    unitCost: 220.0,
    vendor: "Alhambra Foundry Co.",
    leadTimeDays: 14,
    lastOrderDate: "2025-12-15",
  },
  {
    id: "rm-10",
    materialCode: "GR-2403",
    name: "24\" dia x 3\" Grade Ring (MHGR2403)",
    category: "concrete",
    unit: "ea",
    inStock: 28,
    reserved: 12,
    parLevel: 40,
    reorderPoint: 14,
    reorderQty: 20,
    usagePerPiece: 1,
    unitCost: 33.0,
    vendor: "Mid-State (in-house)",
    leadTimeDays: 1,
    lastOrderDate: "2026-01-22",
  },
  {
    id: "rm-11",
    materialCode: "GR-2402",
    name: "24\" dia x 2\" Grade Ring (MHGR2402)",
    category: "concrete",
    unit: "ea",
    inStock: 16,
    reserved: 8,
    parLevel: 28,
    reorderPoint: 10,
    reorderQty: 14,
    usagePerPiece: 1,
    unitCost: 33.0,
    vendor: "Mid-State (in-house)",
    leadTimeDays: 1,
    lastOrderDate: "2026-01-22",
  },
  {
    id: "rm-12",
    materialCode: "FRO-NOX",
    name: "Form Release Oil (Nox-Crete)",
    category: "chemical",
    unit: "gal",
    inStock: 14,
    reserved: 0,
    parLevel: 24,
    reorderPoint: 6,
    reorderQty: 18,
    usagePerPiece: 0.4,
    unitCost: 16.50,
    vendor: "Nox-Crete Products Group",
    leadTimeDays: 3,
    lastOrderDate: "2026-01-18",
  },
];

export const createMockStructureCastRawMaterialStore = () =>
  new MockServiceStore<StructureCastRawMaterial>({
    mockData: mockStructureCastRawMaterials,
    idField: "id",
    simulateDelay: 200,
    persistKey: "preferred-structurecast-raw-materials",
  });
